module.exports = __webpack_public_path__ + "static/media/grabit_red.93b9150c.svg";